import React from 'react';
import { Box, Typography, Paper, Chip, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { Button } from 'react-admin';

export const OnboardingDashboard = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>Onboarding Dashboard</Typography>

    <Grid container spacing={2} sx={{ mb: 3 }}>
      {[
        { label: 'Active Onboardings', value: '12', color: 'primary.main' },
        { label: 'Completed This Month', value: '8', color: 'success.main' },
        { label: 'Pending Documents', value: '5', color: 'warning.main' },
        { label: 'Overdue Start Dates', value: '2', color: 'error.main' },
      ].map(stat => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={stat.label}>
          <Paper sx={{ p: 3, borderTop: '4px solid', borderColor: stat.color }}>
            <Typography variant="body2" color="text.secondary">{stat.label}</Typography>
            <Typography variant="h4" sx={{ mt: 0.5, fontWeight: 700 }}>{stat.value}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>

    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>Onboarding Pipeline</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[
              { stage: 'Documentation', count: 4, color: 'info.main' },
              { stage: 'Contract Signing', count: 3, color: 'warning.main' },
              { stage: 'POPIA Consent', count: 2, color: 'default' },
              { stage: 'System Provisioning', count: 2, color: 'default' },
              { stage: 'Complete', count: 8, color: 'success.main' },
            ].map(s => (
              <Box key={s.stage} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: s.color }} />
                <Typography variant="body2" sx={{ flex: 1 }}>{s.stage}</Typography>
                <Chip label={s.count} size="small" />
              </Box>
            ))}
          </Box>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>Contract Alerts</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[
              { type: 'Probation Expiry', count: 3, color: 'warning.main' },
              { type: 'Fixed-Term Expiry', count: 5, color: 'info.main' },
              { type: 'Actioned', count: 12, color: 'success.main' },
              { type: 'Dismissed', count: 2, color: 'default' },
            ].map(a => (
              <Box key={a.type} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: a.color }} />
                <Typography variant="body2" sx={{ flex: 1 }}>{a.type}</Typography>
                <Chip label={a.count} size="small" />
              </Box>
            ))}
          </Box>
          <Box sx={{ mt: 2 }}>
            <Button component={Link} to="/contract-alerts" variant="outlined" size="small" fullWidth>
              View All Alerts
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  </Box>
);
